window.Config || (window.Config = {});

window.Config = (function(Config) {
	var isDevMode = location.hostname === 'kadapp.pravo.ru',
		host = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/',
		requestHost = host + (isDevMode ? 'JSON/' : '');

	return {
		host: host,
		requestHost: requestHost,
		isDev: ['localhost', 'kadlabs.pravo.ru'].indexOf(location.hostname) !== -1,
		imgHost: host + 'static/img/',
		cssHost: host + 'static/css/',
		jsHost: host + 'static/js/',
		services: {
			'search': 'api/v1/Document/Search',
			'checkFiles': 'api/v1/Signature/Check'
		}
	}
})(window.Config || {});
